<div>
  <div class="prose">
    <h1>Company Information</h1>
  </div>

  @if (loadingTenant) {
    <div class="skeleton mt-8 h-52 w-52"></div>
  } @else if (tenant) {
    <div class="mt-8 text-lg">
      <div class="table-row">
        <div class="table-cell pb-2 text-right opacity-80">Account #:</div>
        <div class="table-cell pb-2 pl-4">
          <p>{{ tenant.account_number }}</p>
        </div>
      </div>

      <div class="table-row">
        <div class="table-cell pb-2 text-right opacity-80">Company:</div>
        <div class="table-cell pb-2 pl-4">
          <p>{{ tenant.company }}</p>
        </div>
      </div>

      <div class="table-row">
        <div class="table-cell pb-2 text-right opacity-80">
          Shipping Address:
        </div>
        <div class="table-cell pb-2 pl-4">
          <p>{{ tenant.address }}</p>
          @if (tenant.address2) {
            <p>{{ tenant.address2 }}</p>
          }
          <p>{{ tenant.city }}, {{ tenant.st }} {{ tenant.zip }}</p>
        </div>
      </div>

      <div class="table-row">
        <div class="table-cell pb-2 text-right opacity-80">
          Billing Address:
        </div>
        <div class="table-cell pb-2 pl-4">
          <p>{{ tenant.billing_address }}</p>
          @if (tenant.billing_address2) {
            <p>{{ tenant.billing_address2 }}</p>
          }
          <p>
            {{ tenant.billing_city }}, {{ tenant.billing_st }}
            {{ tenant.billing_zip }}
          </p>
        </div>
      </div>

      <div class="table-row">
        <div class="table-cell pb-2 text-right opacity-80">Emails:</div>
        <div class="table-cell pb-2 pl-4">
          @for (email of tenant.emails; track email) {
            <p>{{ email }}</p>
          } @empty {
            <p>No Emails</p>
          }
        </div>
      </div>

      <div class="table-row">
        <div class="table-cell pb-2 text-right opacity-80">Billing Emails:</div>
        <div class="table-cell pb-2 pl-4">
          @for (email of tenant.billing_emails; track email) {
            <p>{{ email }}</p>
          } @empty {
            <p>No Billing Emails</p>
          }
        </div>
      </div>

      <div class="table-row">
        <div class="table-cell pb-2 text-right opacity-80">Phone #s:</div>
        <div class="table-cell pb-2 pl-4">
          @if (tenant.phone1) {
            <p>{{ tenant.phone1 }}</p>
          }
          @if (tenant.phone2) {
            <p>{{ tenant.phone2 }}</p>
          }
          @if (!tenant.phone1 && !tenant.phone2) {
            <p>No Phone Numbers</p>
          }
        </div>
      </div>

      <div class="table-row">
        <div class="table-cell pb-2 pt-4 text-right">
          <button
            class="btn btn-primary btn-sm"
            [routerLink]="'../update-info'"
          >
            Edit Info
          </button>
        </div>
        <div class="table-cell pb-2 pl-4 pt-4"></div>
      </div>
    </div>

    @if (canManagePaymentMethods && false) {
      <div class="divider my-8"></div>
      <h4 class="text-xl">Autopay Settings</h4>
      <div class="mt-4 flex w-72 items-center justify-between">
        <div>
          <div class="stat-title">Autopay</div>
          <div
            class="stat-value"
            [ngClass]="{
              'text-success': tenant.autopay_enabled && !showAutopayWarning,
              'text-warning': showAutopayWarning,
              'text-error': !tenant.autopay_enabled,
            }"
          >
            {{ tenant.autopay_enabled ? 'On' : 'Off' }}
          </div>
          <div class="stat-desc">Use toggle to enable/disable</div>
        </div>
        <div
          [ngClass]="{
            'text-success': tenant.autopay_enabled && !showAutopayWarning,
            'text-warning': showAutopayWarning,
            'text-error': !tenant.autopay_enabled,
          }"
        >
          <input
            type="checkbox"
            class="toggle toggle-lg"
            [ngClass]="{
              'toggle-success': tenant.autopay_enabled,
              'toggle-warning': showAutopayWarning,
            }"
            (click)="handleAutopayToggle($event)"
            [checked]="tenant.autopay_enabled"
          />
        </div>
      </div>

      @if (showAutopayWarning) {
        <div role="alert" class="alert alert-warning mt-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="h-6 w-6 shrink-0 stroke-base-300"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <span
            >You have selected to disable autopay. This will require manual
            payment of all invoices to stay current on payments. With autopay
            disabled nothing will be paid for automatically without manual
            intervention.</span
          >
          <div>
            <button
              class="btn btn-neutral btn-sm"
              (click)="showAutopayWarning = false"
            >
              Cancel
            </button>
          </div>
          <div>
            <button class="btn btn-error btn-sm" (click)="disableAutopay()">
              Disable Autopay
            </button>
          </div>
        </div>
      }

      <div class="divider my-8"></div>

      <div class="mb-4 flex">
        <h4 class="text-xl">Saved Payment Methods</h4>
        <button
          class="btn btn-primary btn-sm ml-16"
          (click)="addPaymentMethodModal.showAddMethodModal()"
        >
          <app-plus-icon class="h-4 w-4"></app-plus-icon> Add
        </button>
      </div>
      @if (errorFetchingPaymentMethods) {
        <div class="text-center">
          <p class="text-error">{{ errorFetchingPaymentMethods }}</p>
        </div>
      } @else if (savedPaymentMethods) {
        <div>
          <div class="mt-4">
            <div class="flex flex-wrap">
              @for (paymentMethod of savedPaymentMethods; track paymentMethod) {
                <app-saved-payment-card
                  [paymentMethod]="paymentMethod"
                  [canManagePaymentMethods]="canManagePaymentMethods"
                  [settingDefaultMethod]="settingDefaultMethod"
                  (setDefault)="setDefaultPaymentMethod($event)"
                  (setApiDefault)="setApiDefaultPaymentMethod($event)"
                  (deleteMethod)="confirmDeleteSavedMethod($event)"
                ></app-saved-payment-card>
              } @empty {
                <p>No saved payment methods</p>
              }
            </div>
          </div>

          @if (savedPaymentError) {
            <div class="mt-4 text-center text-error">
              <p>{{ savedPaymentError }}</p>
            </div>
          }
        </div>
      }
    }
  }
</div>

<app-add-payment-method-modal
  #addPaymentMethodModal
  (methodCreated)="handlePaymentMethodCreation($event)"
></app-add-payment-method-modal>

<app-remove-payment-method-modal
  #removePaymentMethodModal
  [methodToRemove]="methodToRemove"
  (deleted)="savedMethodDeleted($event)"
></app-remove-payment-method-modal>
